<template>
  <Main>
    <v-row>
      <v-col cols="12" sm="8" md="9" class="pr-sm-5">
        <BaseFilter
          v-model="search"
          v-bind="filterProps"
          textPlaceholder="Buscar"
          @search="searchByFilter"
          v-on:keyup="searchByFilterClickEnter"
        />
      </v-col>
      <v-col cols="12" sm="4" md="3" class="mb-5" v-if="canCreateOffice">
        <BaseButton
          class="secondary text-uppercase subtitle-2 font-weight-bold"
          width="100%"
          @click="newOffice()"
        >
          <v-icon class="pr-4 add-icon">fa-plus</v-icon>
          Novo Escritório
        </BaseButton>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="offices.items"
          :server-items-length="offices.total_count"
          no-data-text="Não há motivos cadastrados."
          :options.sync="filterOptions"
          class="office_table base__datatable"
          @click:row="editOffice"
        >
          <template v-slot:[`item.cnpj`]="{ item }">
            <div :class="borderColor(item.status.id)">
              <div class="office_table__padding">
                {{ convertCNPJ(item.cnpj) }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.restrito`]="{ item }">
            {{ getRestrictName(item.restrito) }}
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            {{ item.status.nome }}
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
  </Main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import { formatDocument } from "@/utils/documents.js";
const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};

const tableHeaders = [
  { text: "CNPJ", value: "cnpj", sortable: true },
  { text: "Nome", value: "nome_fantasia", sortable: true },
  { text: "Qtd. Grupos", value: "quantidade_grupos", sortable: false },
  { text: "Restrito?", value: "restrito", sortable: false },
  { text: "Status", value: "ativo", sortable: true }
];

const colorByStatus = {
  ativo: { color: "light-blue" },
  inativo: { color: "pink" }
};

export default {
  name: "OfficeList",
  mixins: [LoadingRequest, CommonPayload],
  computed: {
    ...mapState("office", ["offices"]),
    ...mapState(["userPermissions"]),
    canCreateOffice() {
      return this.userPermissions.acoes.some(x => x.id == "criar_escritorio");
    },
    canEditOffice() {
      return this.userPermissions.acoes.some(x => x.id == "editar_escritorio");
    }
  },
  data: () => ({
    search: "",
    filterProps: defaultFilterProps,
    filterOptions: defaultFilterOptions(),
    tableHeaders
  }),
  watch: {
    filterOptions: {
      handler(value) {
        this.fetchData(this.getPayload(value));
      },
      deep: true
    }
  },
  mounted() {
    this.fetchData(this.getPayload(this.filterOptions));
  },
  methods: {
    ...mapActions("office", ["requestOfficeList"]),
    convertCNPJ(item) {
      // Exibe o documento no formato que o backend devolve, preservando letras e números.
      return formatDocument(item);
    },
    getRestrictName(item) {
      return item ? "SIM" : "NÃO";
    },
    borderColor(status) {
      const { color } = colorByStatus[status];
      return `office_table__border-${color}`;
    },
    searchByFilter() {
      this.withLoading(
        this.requestOfficeList(this.getPayload(this.filterOptions))
      );
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13)
        this.withLoading(
          this.requestOfficeList(this.getPayload(this.filterOptions))
        );
    },
    fetchData(payload) {
      this.withLoading(this.requestOfficeList(payload));
    },
    editOffice(item) {
      if (this.canEditOffice)
        this.$router.push({ name: "office edit", params: { id: item.id } });
    },
    newOffice() {
      this.$router.push({ name: "office new" });
    },
    getPayload(options) {
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const direction =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      return {
        page,
        page_size: itemsPerPage,
        sort,
        direction,
        query: this.search,
        somente_ativos: false
      };
    }
  }
};
</script>

<style lang="sass">
.office_table
  &__border-light-blue
    border-left: 5px solid #49DCBB
  &__border-pink
    border-left: 5px solid #EF5350
  &__padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
  &.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
    tbody tr td:first-child
      padding: 2px 0px !important
</style>
